import { Box, IconButton } from '@mui/material';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import {
  CustomTextField,
  CustomButton,
  HorizontalForm,
  RESPONSIVE_CONFIG,
  ICONS_CONFIG,
} from '../../../common';
import { changeDateByDays } from '../utils/registerPaymentUtils';

const ConsolidateButton = ({ handleConsolidate, consolidateDate, setConsolidateDate }) => {
  const handleChangeDateByDays = (days) => {
    const newDate = changeDateByDays(consolidateDate, days);
    setConsolidateDate(newDate);
  };

  return (
    <HorizontalForm
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        minHeight: '185px',
        transition: 'all 0.3s ease',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <IconButton
          onClick={() => handleChangeDateByDays(1)}
          size="small"
          sx={{
            backgroundColor: 'white',
            border: '1px solid #ddd',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              transform: 'scale(1.1)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <KeyboardArrowUp />
        </IconButton>

        <CustomTextField
          label="Fecha"
          type="date"
          value={consolidateDate}
          onChange={(e) => setConsolidateDate(e.target.value)}
          size="medium"
          shrinkLabel={true}
          sx={{
            width: '200px',
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
            },
          }}
        />

        <IconButton
          onClick={() => handleChangeDateByDays(-1)}
          size="small"
          sx={{
            backgroundColor: 'white',
            border: '1px solid #ddd',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              transform: 'scale(1.1)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <KeyboardArrowDown />
        </IconButton>
      </Box>

      <CustomButton
        variant="contained"
        buttonIcon={AssignmentTurnedInIcon}
        onClick={handleConsolidate}
        sx={{
          fontSize: RESPONSIVE_CONFIG.FIELDS.buttonFontSize,
          padding: RESPONSIVE_CONFIG.FIELDS.buttonPadding,
          marginTop: 1,
        }}
        iconProps={{
          sx: ICONS_CONFIG.PUBLISH,
        }}
      >
        Conciliar cobros del día seleccionado
      </CustomButton>
    </HorizontalForm>
  );
};

export default ConsolidateButton;
